import Vue from "vue";
import VueResource from "vue-resource";
import { HttpResponse } from "vue-resource/types/vue_resource";

import store from "@/store";

const auth: string = "auth";

Vue.use(VueResource);

export const veosSignatureApi = {
    downloadDocapostSignDocument,
    downloadLogo,
    getInfosPersonne,
    goToSignDocument,
    listDocumentsByIdPer,
    updateSignDocument,
};
/**
 * Liste les documents du client.
 * @returns la liste des documents
 */
function listDocumentsByIdPer(): PromiseLike<HttpResponse> {
  return Vue.http.get(`${store.state[auth].url}rs/rsExtranet2/electronicSignature/listDocumentsByIdPer`);
}

/**
 * Bascule vers Docapost pour signer le document.
 * @param idDoc l'identifiant du document dans VEOS
 * @returns les informations nécessaires à la redirection vers Docapost
 */
function goToSignDocument(idDoc: string): PromiseLike<HttpResponse> {
  return Vue.http.get(`${store.state[auth].url}rs/rsExtranet2/electronicSignature/signDocumentWithSms/${idDoc}`);
}

/**
 * Récupère le document signé chez Docapost.
 * @param {string} idDoc l'identifiant du document dans VEOS
 * @returns le document signé
 */
function downloadDocapostSignDocument(idDoc: string): PromiseLike<HttpResponse> {
  return Vue.http.get(`${store.state[auth].url}rs/rsExtranet2/electronicSignature/signedDocument/${idDoc}`);
}

/**
 * Met à jour le document dans VEOS :
 * - date signature
 * - etat signature
 * - id document chez Docapost
 * @param {string} idDocapost l'identifiant du document chez Docapost
 * @param {string} idDoc l'identifiant du document dans VEOS
 * @returns {void}
 */
function updateSignDocument(idDocapost: string, idDoc: string): PromiseLike<HttpResponse> {
  return Vue.http.get(`${store.state[auth].url}rs/rsExtranet2/electronicSignature/updateSignDocument/`
      + `${idDocapost}/${idDoc}`);
}

/**
 * Récupère le logo de la compagnie
 * @returns le logo
 */
function downloadLogo(): PromiseLike<HttpResponse> {
  return Vue.http.get(`${store.state[auth].url}rs/rsExtranet2/electronicSignature/logo`);
}

/**
 * Récupère les informations du client
 * @returns les informations du client
 */
function getInfosPersonne(): PromiseLike<HttpResponse> {
  return Vue.http.get(`${store.state[auth].url}rs/rsExtranet2/electronicSignature/infosPer`);
}
